module.exports = __webpack_public_path__ + "img/consult_list6.76e80e54.png";